import { pick } from 'lodash';
import request from '@meitu/saas-editor-ui/es/request';
import { getNewResponseData, getResponseMeta } from '@/utils/response';
import {
    copyRecordParmas,
    copyRecordResponse,
    deleteMyPictureResponse,
    DeleteRecordParams,
    DeleteRecordResponse,
    deteleMyPictureParmas,
    fetchMyPictureOfDesignerResponse,
    fetchMyPictureParmas,
    fetchMyPictureResponse,
    fetchRecordDetailParmas,
    fetchRecordDetailResponse,
    FetchRecordListParams,
    FetchRecordListResponse,
    saveMyPictureParmas,
    saveMyPictureResponse,
    saveRecordParmas,
    saveRecordResponse,
} from './index.d';

/**
 * 作图记录列表
 * @docs: https://api-mock.meitu-int.com/project/1594/interface/api/71369
 */
export const fetchRecordList = async function (params: FetchRecordListParams) {
    return await request<FetchRecordListResponse>('/record/get_list.json', {
        method: 'GET',
        params,
    });
};

/**
 * 作图记录删除（支持批量）
 * @docs: https://api-mock.meitu-int.com/project/1594/interface/api/71376
 */
export const deleteRecord = async function (params: DeleteRecordParams) {
    return await request<DeleteRecordResponse>('/record/delete.json', {
        method: 'POST',
        data: params,
    });
};

/**
 *  作图记录列表详情 https://api-mock.meitu-int.com/project/1594/interface/api/71397
 * @param params
 * @returns
 */
export const fetchRecordDetail = async function (params: fetchRecordDetailParmas) {
    const res = await request<fetchRecordDetailResponse>('/record/detail.json', {
        method: 'GET',
        params,
    });
    let data;
    if (res.data.data?.material) {
        data = {
            ...getResponseMeta(res.data),
            response: {
                ...pick(res.data?.data, ['id', 'threshold', 'updated_at']),
                ...pick(res.data?.data.material, ['material_id']),
                ...pick(res.data?.data.material.meta, ['preview', 'formula']),
            },
        };
    } else {
        data = {
            ...getResponseMeta(res.data),
            response: {},
        };
    }

    return getNewResponseData(res, data);
};

/**
 *  复制作图记录 https://api-mock.meitu-int.com/project/1594/interface/api/71383
 * @param params
 * @returns
 */
export const copyRecord = async function (params: copyRecordParmas) {
    return await request<copyRecordResponse>('/record/copy.json', {
        method: 'POST',
        data: params,
    });
};

/**
 *  保存作图记录 https://api-mock.meitu-int.com/project/1594/interface/api/71390
 * @param params
 * @returns
 */
export const saveRecord = async function (params: saveRecordParmas) {
    const res = await request<saveRecordResponse>('/record/save.json', {
        method: 'POST',
        data: params,
    });

    let data;

    data = {
        ...getResponseMeta(res.data),
        response: res.data.data,
    };

    return getNewResponseData(res, data);
};

/**
 *  我的-保存
 * @param params
 * @returns
 */
export const saveMyPicture = async function (params: saveMyPictureParmas) {
    return await request<saveMyPictureResponse>('/my_picture/save.json', {
        method: 'POST',
        data: params,
    });
};

/**
 *  我的-获取列表
 * @param params
 * @returns
 */
export const fetchMyPicture = async function (params: fetchMyPictureParmas = {}) {
    const res = await request<fetchMyPictureOfDesignerResponse>('/my_picture/get_list.json', {
        method: 'GET',
        params,
    });
    return {
        lists: res.data.response.lists,
        total: res.data.response.total,
    };
};

/**
 *  我的-删除
 * @param params
 * @returns
 */
export const deleteMyPicture = async function (params: deteleMyPictureParmas) {
    return await request<deleteMyPictureResponse>('/my_picture/delete.json', {
        method: 'POST',
        data: params,
    });
};
